import { useState, useEffect} from "react"
import api from '../api'
import { chk_img, lang, gotoURL, gotoLink } from '../lang'
import { useNavigate } from 'react-router-dom';
import SwiperCore, { Navigation, Pagination, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import SwiperNavigation from "../Template/Swiper/SwiperNavigation";

SwiperCore.use([Navigation, Pagination, A11y]);
export default function Ebook(props) {
    const [resources, setResources] = useState([]);
    const [book_type, setBookType] = useState('e-book');
	const navigate = useNavigate();
    SwiperCore.use([Autoplay]); // start autoplay
    const styles = props.styles;

    useEffect(()=>{
        const fetchBook = async () =>{
            try {
              const response = await api.get(`/book/type/${book_type}?show=12`);
              setResources(response.data.results);
              
            } catch (err) {
                if(err.response){
                    //Not in 202 response range
                    console.log(err.response.data);
                    console.log(err.response.headers);
                    console.log(err.response.status);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
          }
        fetchBook();
    },[book_type]);
    return (
        <section className="py-8 flex flex-col">
            {/* Header */}
            <div className="container mx-auto w-full">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 w-full">
                    <div>
                        <h2 className="text-3xl font-bold text-gray-800">
                            {lang("ทรัพยากรสารสนเทศใหม่", "New Arrival")}
                        </h2>

                        <p className="text-gray-500 mt-1">
                            {lang(
                                "หนังสือและสื่อที่เพิ่มเข้าห้องสมุดล่าสุด",
                                "Recently added books and media"
                            )}
                        </p>
                    </div>

                    <button
                        onClick={() => navigate("/books")}
                        className="inline-flex items-center gap-2 text-primary font-semibold hover:text-blue-700"
                    >
                        {lang("ดูทั้งหมด", "View All")}

                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Card */}
            <div className="container mx-auto rounded-xl shadow-sm flex flex-col bg-white">

                {/* Tabs */}

                <div className="hidden md:flex bg-white">

                    <button
                        onClick={() => setBookType("book")}
                        className={`flex-1 py-4 border ${
                            book_type === "book"
                                ? "border-t-4 border-primary text-primary border-b-0"
                                : "text-gray-700"
                        }`}
                    >
                        {lang("หนังสือใหม่", "Books")}
                    </button>

                    <button
                        onClick={() => setBookType("journal")}
                        className={`flex-1 py-4 border ${
                            book_type === "journal"
                                ? "border-t-4 border-primary text-primary border-b-0"
                                : "text-gray-700"
                        }`}
                    >
                        {lang("วารสาร", "Journal")}
                    </button>

                    <button
                        onClick={() => setBookType("e-book")}
                        className={`flex-1 py-4 border ${
                            book_type === "e-book"
                                ? "border-t-4 border-primary text-primary border-b-0"
                                : "text-gray-700"
                        }`}
                    >
                        E-Book
                    </button>

                    <button
                        onClick={() => setBookType("e-journal")}
                        className={`flex-1 py-4 border ${
                            book_type === "e-journal"
                                ? "border-t-4 border-primary text-primary border-b-0"
                                : "text-gray-700"
                        }`}
                    >
                        E-Journal
                    </button>

                    <button
                        onClick={() => setBookType("vetmet-problem")}
                        className={`flex-1 py-4 border ${
                            book_type === "vetmet-problem"
                                ? "border-t-4 border-primary text-primary border-b-0"
                                : "text-gray-700"
                        }`}
                    >
                        {lang(
                            "รายงานปัญหาพิเศษ",
                            "Special Problem"
                        )}
                    </button>

                </div>

                {/* Mobile */}

                <select
                    className="sm:hidden w-full border-b-4 p-3 border border-gray-200 rounded-t-2xl pt-4 border-b-primary focus-within:outline-none cursor-pointer"
                    value={book_type}
                    onChange={(e)=>{e.preventDefault(); setBookType(e.target.value);}}
                >
                    <option value="book">
                        {lang("หนังสือใหม่","Books")}
                    </option>

                    <option value="journal">
                        {lang("วารสาร","Journal")}
                    </option>

                    <option value="e-book">
                        E-Book
                    </option>

                    <option value="e-journal">
                        E-Journal
                    </option>

                    <option value="vetmet-problem">
                        {lang("รายงานปัญหาพิเศษ","Special Problem")}
                    </option>

                </select>

                {/* Shelf */}

                <div className="relative border border-gray-200 border-t-0 rounded-b-xl min-h-[390px]">

                    <button className="swiper-button-prev-unique absolute !left-0 top-1/2 -translate-y-1/2 z-20 w-10 !h-10 bg-primary !text-white flex items-center justify-center">
                        <FaChevronLeft />
                    </button>

                    <button
                        className="swiper-button-next-unique absolute !right-0
                        top-1/2 -translate-y-1/2 z-20 w-10 !h-10 bg-primary !text-white flex items-center justify-center">
                        <FaChevronRight />
                    </button>

                    <div className="h-full flex items-center px-12">
                        <Swiper 
                            spaceBetween={28} 
                            speed={800}
                            autoplay={{ delay:3000 }}
                            breakpoints={{
                                320:{
                                    slidesPerView:2
                                },
                                640:{
                                    slidesPerView:3
                                },
                                768:{
                                    slidesPerView:4
                                },
                                1024:{
                                    slidesPerView:5
                                }
                            }}
                            navigation={{
                                nextEl:".swiper-button-next-unique",
                                prevEl:".swiper-button-prev-unique"
                            }}
                        >
                        {(!resources || resources.length === 0) ? (
                        <div className="text-center py-16">
                            <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                            </svg>
                            <p className="text-gray-500">
                                {lang("ยังไม่มีข้อมูล","No items available")}
                            </p>
                        </div>
                        ):""}
                            {resources.map(item=>(
                                <SwiperSlide key={item.id}>
                                    <div className="group text-center">
                                        <div className="pt-2">
                                            <div
                                                className="w-36 h-52 mx-auto overflow-hidden border border-gray-200 bg-white shadow-sm transition-all duration-300 group-hover:-translate-y-2 group-hover:shadow-xl">
                                                <img
                                                    src={chk_img(item.img_url)}
                                                    alt={item.title}
                                                    className="w-full h-full object-cover cursor-pointer"
                                                    onClick={()=>{
                                                        if(item.book_type==="e-book"||item.book_type==="e-journal")
                                                            gotoLink(item.link)
                                                        else
                                                            gotoURL("/book/"+item.id)

                                                    }}
                                                />
                                            </div>

                                        </div>

                                        <h3 className="mt-3 !text-base font-medium leading-5 text-gray-800 !line-clamp-1 group-hover:text-primary">
                                            {item.title}
                                        </h3>

                                        <p className="!text-sm text-gray-500 line-clamp-1">
                                            {item.author}
                                        </p>

                                    </div>

                                </SwiperSlide>

                            ))}

                        </Swiper>

                    </div>

                </div>

            </div>
</section>
    )
}
